module.exports = __webpack_public_path__ + "static/media/bluescope.d18771e3.png";